import {
  createActions, asyncInitialState, asyncSelectors,
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clearLines: () => null
}, 'categories');


const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  columns: [
    { headerName: 'Price category', field: 'Category', minWidth: 120, suppressSorting: true, },
    { headerName: 'Category', field: 'CategoryPercentDisplay', type: 'numericColumn', minWidth: 120, suppressSorting: true, },
    { headerName: 'Result percentage', field: 'ResultPercent', minWidth: 150, suppressSorting: true, },
    { headerName: 'Nett price', field: 'NettPriceDisplay', type: 'numericColumn', minWidth: 150, suppressSorting: true, },
    { headerName: 'Resident', field: 'ResidentDisplay', type: 'numericColumn', minWidth: 150, suppressSorting: true, },
    { headerName: 'GP', field: 'GrossProfitPercentDisplay', type: 'numericColumn', minWidth: 100, suppressSorting: true, },
    { headerName: 'Special', field: 'IsSpecialDisplay', minWidth: 100, suppressSorting: true, },
  ],
  Data: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.priceCheck.categories,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.priceCheck.categories.loading,
  gridOptions: state => state.priceCheck.categories.data.gridOptions,
  columns: state => state.priceCheck.categories.data.columns,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)